export const styles = {
  formContainer: {
    width:{
      xs:"auto",
      sm:"500px"
    },
    // maxWidth: "500px",
    margin:{
      xs:"0 15px",
      sm:"0 auto"
    },
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  formInput:{
    margin:"10px 0",
  },
  loginTitle:{
    marginBottom:4,
    fontSize:"40px"
  },
  formButton:{
    marginTop:2
  },
  formData:{
    width:"100%"
  }
};
